<template>
    <div class="basket-item">
            <div class="basket-item-header">
                <div class="basket-item-h1">
                    <div class="basket-item-h1-inner">
                        <template v-if="item.product.images.length > 0">
                            <a :href="'/product/' + item.product.slug" class="basket-item-img" :style="'background-image: url(' + item.product.images[0] + ');'"></a>
                        </template>
                        <template v-else>
                                <a :href="'/product/' + item.product.slug" class="basket-item-img" style="background-image: url(/i/nophoto.png);"></a>
                        </template>
                        <div class="basket-item-control">
                            <button v-if="!inFavourites(item.product.id)" type="button" class="btn btn-outline-regular btn-bi btn-fav"
                                    @click.prevent="addToFavourites(item.product.id)">
                                <i class="bi bi-suit-heart"></i><ins>В избранное</ins>
                            </button>
                            <button v-else type="button" class="btn btn-bi btn-cart"
                                    @click.prevent="deleteFromFavourites(item.product.id)">
                                <i class="bi bi-suit-heart-fill"></i><ins>В избранном</ins>
                            </button>
                            <button type="button" class="btn btn-outline-cart btn-bi btn-cart"
                                    @click.prevent="deleteFromCart(item.product.id)">
                                <i class="bi bi-trash"></i><ins>Удалить</ins>
                            </button>
                        </div>
                    </div>
                    <div class="basket-item-info">
                        <div class="articul">Артикул {{ item.product.sku }}</div>
                        <div class="link"><a :href="'/product/' + item.product.slug" class="item-link">{{ item.product.name }}</a></div>
                        <div v-if="!isSizesSelected()" class="status danger">Размеры не выбраны</div>
                        <div v-if="isAvailabilityChanged()" class="status danger">Доступность размеров изменилась</div>
                    </div>
                </div>
                <div class="basket-item-h2">
                    <div class="basket-item-price item-price item-price-h3">
                        <span v-if="item.product.price_old_formatted" class="price-old">{{ item.total_old_formatted }}Р</span>
                        <span v-if="item.product.discount" class="price-off">{{ item.product.discount }}Р</span>
                        <span class="price-current">{{ item.total_formatted }}Р</span>
                    </div>
                    <div v-if="this.canSeeQty" class="basket-item-switch">
                        <button type="button" class="btn btn-outline-regular btn-basket">
                            <ins>
                                <span v-if="!this.show_sizes" @click.prevent="this.showSizes">Показать размеры</span>
                                <span v-else @click.prevent="this.hideSizes">Скрыть размеры</span>
                            </ins>
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="this.canSeeQty && this.show_sizes" class="stock basket-item-stock">
                <cart-item-sizes :id="item.product.id"></cart-item-sizes>
            </div>
        </div>
</template>

<script>
export default {
    props: ["item"],

    data: function () {
        return {
            show_sizes: false
        };
    },

    methods: {
        deleteFromCart(id) {
            this.$store.dispatch('cart/deleteFromCart', id);
        },

        inFavourites(id) {
            // return false;
            return this.$store.state.favourites.items.find(x => x.id == id);
        },

        isSizesSelected() {
            let item = this.$store.state.cart.items.find(x => {
                return x.product.id == this.item.product.id;
            });

            if (item && item.arrivals) {
                for (let date in  item.arrivals) {
                    for (let size in  item.arrivals[date].sizes) {
                        if (typeof item.arrivals[date].cart !== 'undefined'
                            && typeof item.arrivals[date].cart[size] !== 'undefined'
                            && item.arrivals[date].cart[size] > 0
                        ) {
                            return true;
                        }
                    }
                }
            }

            return false;
        },

        isAvailabilityChanged() {
            let item = this.$store.state.cart.items.find(x => {
                return x.product.id == this.item.product.id;
            });

            if (item && item.arrivals) {
                for (let date in  item.arrivals) {
                    for (let size in  item.arrivals[date].sizes) {
                        if (typeof item.arrivals[date].cart !== 'undefined'
                            && typeof item.arrivals[date].cart[size] !== 'undefined'
                            && item.arrivals[date].cart[size] > item.arrivals[date].sizes[size]
                        ) {
                            return true;
                        }
                    }
                }
            }

            return false;
        },

        addToFavourites(id) {
            this.$store.dispatch('favourites/addToFavourites', id)
        },

        deleteFromFavourites(id) {
            this.$store.dispatch('favourites/deleteFromFavourites', id)
        },

        showSizes() {
            this.show_sizes = true;
        },

        hideSizes() {
            this.show_sizes = false;
        }
    },
    computed: {
        canSeeQty() {
            return this.$store.state.isAuth && this.$store.state.isActive;
        },
    },
};
</script>
